import { render } from "./AddFirmware.vue?vue&type=template&id=ef12a086&lang=html"
import script from "./AddFirmware.vue?vue&type=script&lang=js"
export * from "./AddFirmware.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__